import {getBookIdWithPrefix} from "../../../utils/content/content";
import {makeRequest} from "../../baseApi";
import {parseResponseDefault} from "../../not-sorted.utils";
import {BOOK_PERMISSION} from "../../../utils/content/content.constants";

export const relevantSearchRequest = (query, context, extras, limit, offset) => {
  const lang = extras["lang"] || "en";
  const section = extras["section"];
  const order = extras.order ? "&order=" + extras.order : "";

  const url =
    "related/search/" +
    lang +
    "/" +
    section +
    "/" +
    context +
    "?query=" +
    encodeURIComponent(query) +
    order +
    "&limit=" +
    limit +
    "&offset=" +
    offset;

  // console.groupCollapsed(`🔍 RS ${query} [${limit}] (${lang || "no lang"})`);
  // console.table({
  //   queryEncoded: encodeURIComponent(query),
  //   lang,
  //   section,
  //   context,
  //   order,
  //   limit,
  //   offset,
  // });
  // console.groupEnd();

  const request = {
    url,
    type: "get",
    parseResponse: (response) => {
      const {total} = response.data;
      console.log("relevantSearch:response", response);
      const results = response.data.results.map((item, k) => {
        if (item.index) {
          return {
            query,
            ...item,
            isForSale: item.action_required === BOOK_PERMISSION.purchased,
            id: getBookIdWithPrefix(item.para_id),
            className: "book",
          };
        }
        return {
          query,
          index: offset + k,
          ...item,
          isForSale: item.action_required === BOOK_PERMISSION.purchased,
          id: getBookIdWithPrefix(item.para_id),
        };
      });
      return {total, results, languageFacets: {}};
    },
  };
  return makeRequest(request);
};

export const searchTopicsRequest = (searchValue) => {
  return makeRequest({
    url: `search/related/topics?query=${encodeURIComponent(searchValue)}&lang=en`,
    type: "get",
    memoryCache: true,
    parseResponse: parseResponseDefault,
  });
};
